import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from './session.service';

export const authGuard: CanActivateFn = async () => {
    
    const sessionService: SessionService = inject(SessionService);
    const router = inject(Router);

    if (await sessionService.isAuthenticated()) {
        return true;
    }

    router.navigate(['/login']);
    return false;

};

export const publicGuard: CanActivateFn = async () => {
    
    const sessionService: SessionService = inject(SessionService);
    const router = inject(Router);

    if (!(await sessionService.isAuthenticated())) {
        return true;
    }

    router.navigate(['/boards']);
    return false;

};
